﻿module Client.ContractPage.PurchaseOrders.PurchaseOrders

open Feliz
open Model
open Shared

let View model contractSettings (contract: Contract) purchaseOrders dispatch =

  let addRequesting = contractSettings.PurchaseOrderSettings.Requests
  
  Html.div [
    prop.style [
      style.paddingBottom(length.px 50)
      style.justifyContent.spaceAround
    ]
    prop.children [
      match contractSettings.PurchaseOrderSettings.Version with
      | Basic -> Basic.View addRequesting contract purchaseOrders dispatch
      | OrderItemReport -> OrderItemReport.View
                             {| Po = purchaseOrders
                                Model = model
                                Dispatch = dispatch
                                AddRequesting = addRequesting
                                Contract = contract |}
      
      if contractSettings.PurchaseOrderSettings.Requests then
        RequestModal.View model contract dispatch
    ]
  ]